import React, { useState } from 'react';
import { Box, IconButton, Link } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import { DropdownFilter } from '../../Planner/Filters/DropdownFilter';
import { useFetchOrgUnitOptions } from '../../../actions/areas/shared/fetchOptions';
import { ClinicianGroupType, ClinicianGroupTypeOptions } from '../../../enums/clinicianGroupType';
import globals from '../../../globals/communityGlobals';
import KeyboardDateSelector from '../../common/KeyboardDateTimeSelectors/KeyboardDateSelector';
import { isDateFromBeforeDateTo, isValidDate } from '../../../utils/dates';

const defaultState = {
  orgUnitId: '',
  validFromDate: null,
  validToDate: null,
  clinicianGroupType: ClinicianGroupType.Active,
  errorMsg: null,
};

export default function ClinicianGroupFilters({ onSubmit }) {
  const locale = globals.getAreas(['clinicianGroups', 'error']);

  const [state, setState] = useState(defaultState);

  const { data: orgUnitOptions } = useFetchOrgUnitOptions(false);

  const clear = () => {
    setState(defaultState);
    onSubmit(defaultState);
  };

  const areDatesValid =
    isValidDate(state.validFromDate, true) &&
    isValidDate(state.validToDate, true) &&
    isDateFromBeforeDateTo(state.validFromDate, state.validToDate, true);

  return (
    <section className="slick-page-header-section">
      <Box className="filter-section" display="flex" flexWrap="nowrap" p={0} justifyContent="flex-start" px={1}>
        <Box p={1}>
          <FilterListIcon />
        </Box>
        <Box p={1} width={70} textAlign="end">
          <span>{locale.getMsg('orgUnit')}</span>
        </Box>
        <Box p={1} width={400} flexGrow={1}>
          <DropdownFilter
            data={orgUnitOptions}
            filterKey={'orgUnit'}
            hasAny
            filterValue={state.orgUnitId}
            defaultValue={['']}
            onChange={(name, value) => setState({ ...state, orgUnitId: value })}
          />
        </Box>
        <Box p={1} width={80} textAlign="end">
          <span>Status</span>
        </Box>
        <Box p={1} width={200} flexGrow={1}>
          <DropdownFilter
            data={ClinicianGroupTypeOptions}
            filterKey={'clinicianGroupType'}
            filterValue={state.clinicianGroupType}
            defaultValue={[state.clinicianGroupType]}
            onChange={(name, value) => setState({ ...state, clinicianGroupType: value })}
          />
        </Box>
        <Box p={1} width={90} textAlign="end">
          <span>Date From</span>
        </Box>
        <KeyboardDateSelector
          id="validfrom-picker-inline"
          value={state.validFromDate}
          onChange={date => setState({ ...state, validFromDate: date })}
          className="calendar-picker-input"
          maxDate={state.validToDate || undefined}
          maxDateMessage=""
          disableToolbar
        />
        <Box p={1} width={80} textAlign="end">
          <span>Date To</span>
        </Box>
        <KeyboardDateSelector
          id="validto-picker-inline"
          value={state.validToDate}
          onChange={date => setState({ ...state, validToDate: date })}
          className="calendar-picker-input"
          minDate={state.validFromDate || undefined}
          minDateMessage={locale.getMsg('dateToBeforeDateFrom')}
          disableToolbar
        />
        <Box p={1} width={50} />
        <Box p={1}>
          <Link className="cancel-link" onClick={clear}>
            Clear
          </Link>
        </Box>
        <Box p={1}>
          <IconButton
            type="submit"
            size="small"
            onClick={() => onSubmit(state)}
            disabled={!areDatesValid}
            className="search-icon"
          >
            <SearchIcon />
          </IconButton>
        </Box>
      </Box>
    </section>
  );
}
